<!-- ================非遗文化馆-非遗工坊活动列表====================-->
<template>
    <div class="intangible-offline-page-page">
        <home-head />
        <div class="intangible-offline-page-body">
            <div class="intangible-offline-page-inner">
                <!-- 标题区 -->
                <div class="intangible-offline-page-header">
                    <div class="intangible-offline-page-title-box">
                        <div class="intangible-offline-page-title">{{ itemInfo.itemMonth }} {{ itemInfo.itemName }}</div>
                        <div class="intangible-offline-page-subtitle">{{ itemInfo.itemDesc }}</div>
                    </div>
                    <div class="intangible-offline-page-actions">
                        <div class="back-btn" @click="goBack">
                            <span class="back-arrow">←</span>
                            <span>返回</span>
                        </div>
                    </div>
                </div>

                <!-- 筛选工具栏 -->
                <div class="intangible-offline-page-filter">
                    <div class="filter-left">
                        <div class="filter-item">
                            <span class="filter-label">学段</span>
                            <el-select class="filter-select" v-model="queryParams.periodKey" clearable placeholder="请选择" @change="handleFilterChange">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div>
                        <div class="filter-item">
                            <span class="filter-label">年级</span>
                            <el-select class="filter-select" v-model="queryParams.activityGrade" clearable placeholder="请选择" @change="handleFilterChange">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div>
                    </div>
                    <div class="filter-right">
                        <input class="search-input" type="text" placeholder="请输入关键词" v-model="queryParams.activityName" @keyup.enter="handleSearch" />
                        <div class="search-btn" @click="handleSearch">搜索</div>
                    </div>
                </div>

                <!-- 活动列表 -->
                <div class="event-list" v-loading="loading">
                    <div class="event-card" v-for="(item, index) in activityList" :key="index" @click="handleEventClick(item)">
                        <div class="event-cover">
                            <img class="img-100" :src="item.activityCover" :alt="item.activityName" />
                        </div>
                        <div class="event-info">
                            <div class="event-info-item" :title="item.activityName">
                                <span class="info-label">活动主题：</span>
                                <span class="info-value">{{ item.activityName }}</span>
                            </div>
                            <div class="event-info-item" :title="(item.periodName || '') + '·' + (item.activityGradeName || '')">
                                <span class="info-label">学段年级：</span>
                                <span class="info-value">{{ item.periodName }}{{ item.activityGradeName? item.activityGradeName+'·' : ''}}</span>
                            </div>
                            <div class="event-info-item">
                                <span class="info-label">活动时长：</span>
                                <span class="info-value">{{ item.activityTime  || '--'}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 暂无数据 -->
                <div class="empty-state" v-if="!loading && activityList.length === 0">
                    <div class="empty-icon">
                        <img src="@/assets/image/data_empty.png" alt="暂无数据" />
                    </div>
                    <div class="empty-text">暂无数据</div>
                </div>

                <!-- 分页 -->
                <div class="pagination-wrapper" v-if="total > 0">
                    <pagination :background="false" 
                        :pageSizes="[12, 24, 36]" 
                        :total="total"
                        v-model:page.sync="queryParams.pageNum" 
                        v-model:limit.sync="queryParams.pageSize" 
                        @pagination="pageList" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { pageMuseumActivity } from "@/api/admin/museumActivity";
import { queryDict } from "@/api/admin/dict";
import { infoItem } from "@/api/admin/item";
import homeHead from "@/components/common/homeHead.vue";

export default {
    components: { homeHead },
    name: "intangibleOfflinePage",
    data() {
        return {
            loading: false,
            total: 0,
            activityList: [],
            periodList: [],
            gradeList: [],
            itemId:'',
            itemInfo: {},
            queryParams:{
                activityName:'',
                activityItem:'',
                seasonItem:'',
                periodKey:'',
                museumKey:'3',
                activityGrade:'',
                pageNum: 1,
                pageSize: 12,
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.handleQueryDict();
        if (this.$route.query.item) {
            this.itemId = this.$route.query.item
            this.queryItemInfo();
        }
    },
    mounted() {},
    methods: {
        /* ===============主题详情查询===================== */
        queryItemInfo() {
            infoItem({ itemId: this.itemId}).then(res => {
                if (res.data.code === 1) {
                    this.itemInfo = res.data.data;
                    this.queryParams.activityItem = this.itemId;
                    this.pageList();
                }else{
                    this.$message.error("请求出错");
                }
            });
        },
        
        /* ===============字典查询===================== */
        handleQueryDict() {
            queryDict({ code: "lession_xd_nj_xk" }).then(res => {
                if (res.data.code === 1) {
                    this.periodList = res.data.data || [];
                }
            });
            queryDict({ code: "grade_period" }).then(res => {
                if (res.data.code === 1) {
                    this.gradeList = res.data.data || [];
                }
            });
        },

        /* ===============活动分页查询===================== */
        pageList(e) {
            this.loading = true;
            this.eventList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageMuseumActivity(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total || 0;
                    this.activityList = res.data.data.list || [];
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        /* ===============筛选与搜索===================== */
        handleFilterChange() {
            this.queryParams.pageNum = 1;
            this.pageList();
        },
        handleSearch() {
            this.queryParams.pageNum = 1;
            this.pageList();
        },

        /* ===============跳转===================== */
        goBack() {
            this.$router.back();
        },
        handleEventClick(item) {
            this.$router.push({
                path: "/museum/intangible/offlineInfo",
                query: { activityId: item.activityId },
            });
        },
    }
}
</script>

<style scoped>
.intangible-offline-page-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.intangible-offline-page-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.intangible-offline-page-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px 50px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;
}

/* 标题区 */
.intangible-offline-page-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-shrink: 0;
}

.intangible-offline-page-title-box {
    display: flex;
    flex-direction: column;
}

.intangible-offline-page-title {
    font-size: 24px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 8px;
}

.intangible-offline-page-subtitle {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

.intangible-offline-page-actions {
    display: flex;
    align-items: center;
}

.back-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 28px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

.back-arrow {
    margin-right: 8px;
    font-size: 16px;
}

/* 筛选工具栏 */
.intangible-offline-page-filter {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.filter-left {
    display: flex;
    align-items: center;
    gap: 24px;
}

.filter-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.filter-label {
    font-size: 15px;
    color: #4b5563;
    font-family: sans-serif;
}

.filter-select {
    width: 120px!important;
}

.filter-select .el-select__wrapper {
    min-height: 34px !important;
    height: 34px;
    line-height: 34px;
    font-size: 14px;
}

.filter-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.search-input {
    width: 200px;
    height: 34px;
    line-height: 34px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    font-family: sans-serif;
    box-sizing: border-box;
    background-color: #ffffff;
}

.search-input:focus {
    border-color: #b22222;
}

.search-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 20px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.search-btn:hover {
    background-color: #b22222;
    color: #ffffff;
}

/* 活动列表 */
.event-list {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 60px;
    padding-top: 10px;
    align-content: flex-start;
}
.event-list::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.event-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}
.event-list::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}
.event-list::-webkit-scrollbar-thumb:hover {
    background: #9a9a9a;
}
.event-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 12px;
    cursor: pointer;
    transition: all 0.25s ease;
}

.event-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.event-cover {
    width: 100%;
    aspect-ratio: 16 / 9;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 12px;
    background-color: #f3f4f6;
    border-radius: 4px;
}

.event-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.event-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.event-info-item {
    width: 100%;
    font-size: 13px;
    color: #1f2937;
    font-family: sans-serif;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.info-label {
    color: #4b5563;
}

.info-value {
    color: #1f2937;
}

/* 暂无数据 */
.empty-state {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 60px;
    box-sizing: border-box;
}

.empty-icon {
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
}

.empty-icon img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

/* 分页 */
.pagination-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -10px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.pagination-wrapper .el-pagination__total {
    font-size: 13px;
    color: #6b7280;
}

.pagination-wrapper .el-pagination__jump {
    font-size: 13px;
    color: #6b7280;
}

.pagination-wrapper .el-pager li {
    font-size: 13px;
    color: #4b5563;
}

.pagination-wrapper .el-pager li.active {
    background-color: #b22222;
    color: #ffffff;
}

.pagination-wrapper .el-select .el-input__wrapper {
    height: 28px;
    min-height: 28px;
    font-size: 13px;
}

@media (max-width: 1280px) {
    .intangible-offline-page-inner { padding: 0 20px; }
    .intangible-offline-page-title { font-size: 22px; }
    .event-list { gap: 16px; }
    .filter-left { gap: 18px; }
}

@media (max-width: 1024px) {
    .intangible-offline-page-title { font-size: 20px; }
    .intangible-offline-page-subtitle { font-size: 13px; }
    .intangible-offline-page-filter { flex-wrap: wrap; gap: 12px; }
    .filter-left { gap: 12px; }
    .filter-select { width: 100px; }
    .search-input { width: 160px; }
    .event-list { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
}

@media (max-width: 768px) {
    .intangible-offline-page-header { flex-direction: column; align-items: flex-start; gap: 12px; }
    .intangible-offline-page-filter { flex-direction: column; align-items: flex-start; }
    .filter-right { width: 100%; }
    .search-input { flex: 1; }
    .event-list { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
    .event-card { padding: 8px; }
    .event-info-item { font-size: 12px; }
}
</style>
